module.exports = __webpack_public_path__ + "img/1542258677.cdb6260f.jpg";